var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 362.16 71.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#db2432;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dise\\xF1o"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 3.07,
    width: 11.25,
    height: 68.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.31,71.69a26.62,26.62,0,0,1-26.59-26.6V2.9h11V45.09a15.64,15.64,0,1,0,31.27,0v-42h11v42a26.62,26.62,0,0,1-26.59,26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.87,3.07H77.58V36.35h9.31q8.6,0,13.18-4.36t4.57-12.6q0-7.75-4.41-12T87.87,3.07m-1,28.7H83V7.62h4.71q11.17,0,11.18,12,0,12.21-12,12.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111.22,
    y: 11.18,
    width: 5.35,
    height: 25.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.93,1.52a3,3,0,0,0-2.24.78,2.94,2.94,0,0,0-.79,2.21,2.89,2.89,0,0,0,.79,2.15,3,3,0,0,0,2.24.78,3,3,0,0,0,2.2-.78,2.93,2.93,0,0,0,.78-2.15,3,3,0,0,0-.78-2.21,3,3,0,0,0-2.2-.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135,10.87a17.55,17.55,0,0,0-2.24-.15c-3.18,0-5.64.75-7.36,2.25a8,8,0,0,0-2.58,6.35A8.06,8.06,0,0,0,124,23.77a7,7,0,0,0,3.18,2.75,9,9,0,0,0-2.37,1.93,3.66,3.66,0,0,0-.79,2.39,3.75,3.75,0,0,0,.69,2.13,4.1,4.1,0,0,0,1.76,1.47,7.91,7.91,0,0,0-4.11,2.19,5.58,5.58,0,0,0-1.46,3.91,5.91,5.91,0,0,0,2.7,5.19q2.72,1.82,7.86,1.82,6.66,0,10.19-2.32a7.44,7.44,0,0,0,3.53-6.61A6.26,6.26,0,0,0,143,33.5q-2.16-1.77-6.33-1.77h-4.39a7.14,7.14,0,0,1-3-.43,1.39,1.39,0,0,1-.81-1.3,3,3,0,0,1,1.73-2.5,12.12,12.12,0,0,0,2.19.18,11.26,11.26,0,0,0,7.39-2.23,7.52,7.52,0,0,0,2.69-6.13,7.73,7.73,0,0,0-.39-2.46,6.59,6.59,0,0,0-1-1.95l4.31-.8V11.18h-8.72a13.61,13.61,0,0,0-1.77-.31M130.7,36.26h4.06a9.43,9.43,0,0,1,4.35.69,2.49,2.49,0,0,1,1.18,2.34,3.77,3.77,0,0,1-2.14,3.32,13.31,13.31,0,0,1-6.51,1.25,8.59,8.59,0,0,1-4.38-.93,3,3,0,0,1-1.56-2.67,3.55,3.55,0,0,1,1.35-2.92,5.69,5.69,0,0,1,3.65-1.08m2-12a4.61,4.61,0,0,1-3.5-1.27A5.09,5.09,0,0,1,128,19.32a5.52,5.52,0,0,1,1.2-3.84,4.51,4.51,0,0,1,3.52-1.32,4.36,4.36,0,0,1,3.49,1.33,5.61,5.61,0,0,1,1.15,3.79q0,5-4.64,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.85,1.52a3,3,0,0,0-2.24.78,3,3,0,0,0-.79,2.21,2.93,2.93,0,0,0,.79,2.15,3,3,0,0,0,2.24.78,3,3,0,0,0,2.2-.78,2.93,2.93,0,0,0,.78-2.15,3,3,0,0,0-.78-2.21,3,3,0,0,0-2.2-.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150.14,
    y: 11.18,
    width: 5.35,
    height: 25.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M170,31.56a3.78,3.78,0,0,1-1-2.86V15.23h7.17V11.17H169V5.57h-3.3l-1.82,5.33-3.69,2v2.37h3.44V28.79q0,8,7.6,8a15.26,15.26,0,0,0,2.9-.26,10.93,10.93,0,0,0,2.29-.64v-4a13,13,0,0,1-3.91.61,3.55,3.55,0,0,1-2.54-.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.59,12.81q-2.44-2.09-7.25-2.09a20.82,20.82,0,0,0-4.6.56,18.35,18.35,0,0,0-4.48,1.63L184,16.73a27.49,27.49,0,0,1,3.41-1.35,12.39,12.39,0,0,1,3.71-.56,4.59,4.59,0,0,1,3.5,1.19,5.1,5.1,0,0,1,1.12,3.61V21l-4.34.14q-5.92.18-8.81,2.16a6.65,6.65,0,0,0-2.89,5.87,7.48,7.48,0,0,0,2.08,5.67,8,8,0,0,0,5.79,2A11.69,11.69,0,0,0,192.3,36,10.29,10.29,0,0,0,196,32.84h.18l1.07,3.51H201v-17q0-4.49-2.45-6.58m-2.9,13.71a5.88,5.88,0,0,1-1.77,4.56,6.58,6.58,0,0,1-4.67,1.63,4.34,4.34,0,0,1-3-.92,3.41,3.41,0,0,1-1-2.61A3.83,3.83,0,0,1,187,25.73a11.06,11.06,0,0,1,5.5-1.26l3.23-.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 208.5,
    y: 3.07,
    width: 5.35,
    height: 33.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.39,51.5c0,1,0,2,.07,3h-.07a4.84,4.84,0,0,0-1.87-1.78,5.45,5.45,0,0,0-2.47-.53A5,5,0,0,0,78.89,54a8.3,8.3,0,0,0-1.43,5.22,7.46,7.46,0,0,0,1.44,5,5.17,5.17,0,0,0,4.17,1.7,4.88,4.88,0,0,0,4.32-2.26h.09l.31,2h.79V46.76H87.39Zm0,7.72a6.84,6.84,0,0,1-1,4.28,3.92,3.92,0,0,1-3.27,1.3q-4.35,0-4.35-5.6a7.46,7.46,0,0,1,1.09-4.4,3.71,3.71,0,0,1,3.24-1.51,3.91,3.91,0,0,1,3.31,1.33,7.31,7.31,0,0,1,1,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98,52.19a5.12,5.12,0,0,0-4.18,1.9,7.7,7.7,0,0,0-1.56,5,7.09,7.09,0,0,0,1.61,5,5.72,5.72,0,0,0,4.48,1.78,11.23,11.23,0,0,0,2.09-.18,9.86,9.86,0,0,0,2-.66V63.94a12.17,12.17,0,0,1-2.16.68,11.49,11.49,0,0,1-2,.16,4.48,4.48,0,0,1-3.56-1.43A6.22,6.22,0,0,1,93.5,59.2H103v-1a6.68,6.68,0,0,0-1.35-4.41A4.5,4.5,0,0,0,98,52.19m-4.4,5.94a5.94,5.94,0,0,1,1.34-3.61A4,4,0,0,1,98,53.26a3.28,3.28,0,0,1,2.75,1.29,5.77,5.77,0,0,1,1,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118,47.83l-7.12,17.79h1.37l2.47-6.25h7.2l2.46,6.25h1.39l-7-17.79Zm3.51,10.42h-6.34l2.48-6.36a19.18,19.18,0,0,0,.72-2.11c.28.89.52,1.59.72,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.86,52.19q-3.29,0-4.57,2.06h-.07l-.23-1.8h-1V65.62h1.2V58.35a5.63,5.63,0,0,1,1.09-3.87,4.5,4.5,0,0,1,3.47-1.19,3.38,3.38,0,0,1,2.59.9,4.14,4.14,0,0,1,.84,2.89v8.54h1.19V57c0-3.2-1.5-4.81-4.49-4.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.42,64.07a3.75,3.75,0,0,1-.54-2.24V53.49h3.87v-1h-3.87V49.26h-.61l-.61,3-1.95.55v.7h1.95V62a4.34,4.34,0,0,0,.83,2.93,3.28,3.28,0,0,0,2.58.94,6.16,6.16,0,0,0,2-.3v-1a8.42,8.42,0,0,1-2,.2,1.91,1.91,0,0,1-1.67-.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.52,47.62c-.51,0-.76.39-.76,1.17S151,50,151.52,50a.67.67,0,0,0,.59-.31,1.54,1.54,0,0,0,.21-.86,1.48,1.48,0,0,0-.21-.86.67.67,0,0,0-.59-.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 150.93,
    y: 52.45,
    width: 1.2,
    height: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161,52.19a5.41,5.41,0,0,0-4.3,1.8,7.44,7.44,0,0,0-1.56,5,8.68,8.68,0,0,0,.7,3.61,5.4,5.4,0,0,0,2,2.4,5.57,5.57,0,0,0,3.05.84,5.41,5.41,0,0,0,4.32-1.82,7.44,7.44,0,0,0,1.56-5,7.48,7.48,0,0,0-1.54-5A5.29,5.29,0,0,0,161,52.19m3.35,11.06a4.05,4.05,0,0,1-3.38,1.53,4,4,0,0,1-3.37-1.53,6.65,6.65,0,0,1-1.2-4.23,6.69,6.69,0,0,1,1.18-4.24,4,4,0,0,1,3.37-1.49,4.12,4.12,0,0,1,3.39,1.5,6.62,6.62,0,0,1,1.2,4.23,6.71,6.71,0,0,1-1.19,4.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.51,54.3h-.07a4.83,4.83,0,0,0-4.28-2.11A4.88,4.88,0,0,0,171.07,54a8.12,8.12,0,0,0-1.43,5.15,7.53,7.53,0,0,0,1.43,5,4.93,4.93,0,0,0,4,1.73,4.87,4.87,0,0,0,4.47-2.31h.08c0,1-.08,2-.08,3v5h1.19V52.45h-1Zm.05,4.74a7.4,7.4,0,0,1-1,4.44,4.07,4.07,0,0,1-3.42,1.32A3.72,3.72,0,0,1,172,63.39a6.83,6.83,0,0,1-1.08-4.19,7.43,7.43,0,0,1,1.1-4.41,3.79,3.79,0,0,1,3.25-1.5,3.87,3.87,0,0,1,3.28,1.32,7,7,0,0,1,1,4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.22,59.72a5.56,5.56,0,0,1-1.11,3.87,4.53,4.53,0,0,1-3.46,1.19,3.41,3.41,0,0,1-2.6-.91,4.19,4.19,0,0,1-.83-2.89V52.45H185v8.61c0,3.2,1.5,4.81,4.5,4.81q3.28,0,4.57-2.06h.07l.22,1.81h1V52.45h-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.41,47.62c-.51,0-.76.39-.76,1.17s.25,1.17.76,1.17a.67.67,0,0,0,.59-.31,1.54,1.54,0,0,0,.21-.86,1.48,1.48,0,0,0-.21-.86.67.67,0,0,0-.59-.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 199.82,
    y: 52.45,
    width: 1.2,
    height: 13.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.56,53.35a4.27,4.27,0,0,0-3.25-1.13,10,10,0,0,0-4.29,1l.45,1a8.24,8.24,0,0,1,3.79-1,3,3,0,0,1,2.47,1,4.48,4.48,0,0,1,.76,2.84v.87L210,58a8.74,8.74,0,0,0-4.65,1.13,3.39,3.39,0,0,0-1.6,3,3.55,3.55,0,0,0,1.08,2.75,4.24,4.24,0,0,0,3,1,5.46,5.46,0,0,0,2.48-.53,6.18,6.18,0,0,0,2-1.8h.1l.31,2.08h.88V56.86a5,5,0,0,0-1.07-3.51m-.12,6.87a4.2,4.2,0,0,1-4.54,4.56,3.06,3.06,0,0,1-2.14-.69,2.45,2.45,0,0,1-.76-1.92,2.51,2.51,0,0,1,1.18-2.29,8.87,8.87,0,0,1,4-.86l2.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.53,3.14h2.17V13.21h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.68,3.14h2.15l4.86,6.51V3.14h2.17V13.21h-2.17L244.83,6.7v6.51h-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.16,11.72l1.25-1.48a5,5,0,0,0,3.31,1.32c1.09,0,1.65-.5,1.65-1.13s-.59-.94-2.13-1.29c-2.13-.49-3.64-1.09-3.64-3S256.13,3,258.33,3a5.8,5.8,0,0,1,3.94,1.4l-1.13,1.55a4.63,4.63,0,0,0-2.87-1.11c-.92,0-1.48.48-1.48,1.08s.6,1,2.15,1.32c2.17.48,3.61,1.13,3.61,3s-1.45,3.2-3.91,3.2A6.52,6.52,0,0,1,254.16,11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.6,5.09h-3.14V3.14h8.45V5.09h-3.14v8.12H267.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M275.27,3.14h2.17V13.21h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.94,5.09H279.8V3.14h8.45V5.09h-3.14v8.12h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.57,8.86V3.14h2.15V8.77a2.41,2.41,0,1,0,4.8,0V3.14h2.17V8.86a4.56,4.56,0,0,1-9.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.14,8.17a5.36,5.36,0,0,1,9.27-3.52l-1.57,1.41a3.12,3.12,0,0,0-2.35-1.13,3.25,3.25,0,0,0,0,6.49,3.12,3.12,0,0,0,2.35-1.13l1.57,1.41a5.44,5.44,0,0,1-3.92,1.69A5.36,5.36,0,0,1,302.14,8.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.66,3.14h2.17V13.21h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.32,8.17a5.36,5.36,0,0,1,10.71,0,5.36,5.36,0,0,1-10.71,0Zm8.49,0a3.13,3.13,0,1,0-3.14,3.25A3.24,3.24,0,0,0,326.81,8.17ZM324.61,0l1.92.35-2.17,1.94h-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.59,3.14h2.16l4.85,6.51V3.14h2.17V13.21H338.6L333.75,6.7v6.51h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.49,26.46V20.74h2.15v5.63a2.41,2.41,0,1,0,4.8,0V20.74h2.17v5.72a4.56,4.56,0,0,1-9.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.54,20.74h2.16l4.85,6.51V20.74h2.17V30.81h-2.17L251.7,24.3v6.51h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.72,20.74h2.17V30.81h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.6,20.74l-4.1,10.07h-2.42L266,20.74h2.44l2.88,7.1,2.89-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.84,22.69v2h5.06v1.95h-5.06v2.21h5.59v1.95h-7.76V20.74h7.76v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M295,30.81l-2.3-3.27h-1.6v3.27H289V20.74h4.54a3.49,3.49,0,0,1,3.79,3.4A3.27,3.27,0,0,1,295,27.29l2.48,3.52Zm-3.9-5.25h2.14c1.07,0,1.8-.55,1.8-1.42s-.73-1.42-1.8-1.42h-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.12,29.32l1.25-1.48a5,5,0,0,0,3.31,1.32c1.09,0,1.64-.5,1.64-1.13s-.58-.94-2.12-1.29c-2.13-.49-3.64-1.09-3.64-3s1.52-3.14,3.72-3.14a5.83,5.83,0,0,1,4,1.4l-1.13,1.55a4.65,4.65,0,0,0-2.87-1.11c-.93,0-1.49.48-1.49,1.08s.61,1,2.16,1.32c2.17.49,3.61,1.13,3.61,3s-1.45,3.2-3.92,3.2A6.49,6.49,0,0,1,299.12,29.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310,20.74h2.17V30.81H310Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M317.64,22.69h-3.13v-2H323v2h-3.14v8.12h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.27,29.23h-4.49l-.64,1.58h-2.42l4.1-10.07h2.42l4.11,10.07h-2.43Zm-.75-1.83L329,23.72l-1.5,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.48,30.81l-2.31-3.27h-1.6v3.27h-2.15V20.74H341a3.49,3.49,0,0,1,3.8,3.4,3.27,3.27,0,0,1-2.29,3.15l2.48,3.52Zm-3.91-5.25h2.15c1.07,0,1.8-.55,1.8-1.42s-.73-1.42-1.8-1.42h-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M347.27,20.74h2.17V30.81h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.08,29.23h-4.49L354,30.81h-2.42l4.1-10.07h2.42l4.11,10.07h-2.44Zm-.75-1.83-1.5-3.68-1.49,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.59,38.34h3.61c3.38,0,5.79,2.08,5.79,5s-2.41,5.05-5.79,5.05h-3.61Zm3.88,8.11a3.08,3.08,0,1,0,0-6.14h-1.73v6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M249.57,38.34h2.17V48.42h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.25,42.75h4.46v4.16a5.81,5.81,0,0,1-4.08,1.68,5.21,5.21,0,1,1,0-10.42,5.81,5.81,0,0,1,4.08,1.68l-1.57,1.41a3.45,3.45,0,0,0-2.51-1.13,3.25,3.25,0,0,0,0,6.5,3.44,3.44,0,0,0,2-.65V44.44h-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.44,38.34h2.17V48.42h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.11,40.29H271V38.34h8.45v1.95h-3.14v8.13h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.74,46.83h-4.49l-.65,1.59h-2.42l4.11-10.08h2.42l4.11,10.08h-2.44ZM287,45l-1.5-3.68L284,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,46.47v2h-7.19V38.34H295v8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.59,55.94h3.61c3.38,0,5.79,2.08,5.79,5s-2.41,5-5.79,5h-3.61Zm3.88,8.11a3.08,3.08,0,1,0,0-6.14h-1.73v6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.71,57.89v2h5.06v2h-5.06v2.22h5.59v2h-7.76V55.94h7.76v2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.54,64.43h-4.48L266.41,66H264l4.11-10.08h2.42L274.62,66h-2.43Zm-.75-1.83-1.49-3.68-1.5,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.78,55.94h2.16l4.85,6.51V55.94H286V66h-2.17l-4.85-6.51V66h-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.53,57.89H288.4v-2h8.44v2h-3.13V66h-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.21,55.94h2.17V66h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.87,61a5.36,5.36,0,1,1,5.35,5.22A5.35,5.35,0,0,1,303.87,61Zm8.49,0a3.13,3.13,0,1,0-3.14,3.26A3.25,3.25,0,0,0,312.36,61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.41,63.92l.94.82L326.25,66l-1-.9A5.25,5.25,0,0,1,322,66.19,5.21,5.21,0,1,1,327.37,61,5.1,5.1,0,0,1,326.41,63.92Zm-2.78-.18-1.18-1,1.1-1.28,1.22,1.06a3.18,3.18,0,0,0,.38-1.53A3.13,3.13,0,1,0,322,64.23,2.94,2.94,0,0,0,323.63,63.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.83,61.66V55.94H332v5.63a2.41,2.41,0,1,0,4.79,0V55.94H339v5.72a4.56,4.56,0,0,1-9.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.83,55.94H344V66h-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M353.64,64.43h-4.49L348.5,66h-2.42l4.11-10.08h2.42L356.72,66h-2.44Zm-.75-1.83-1.5-3.68L349.9,62.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.db2687968c84ed7b25571b77beb723e1.svg";
export { ForwardRef as ReactComponent };